/**
 * TODO 1 This definition could be done in TS. Should it be part of valid-values project?
 * TODO We should start with pure elabels import. So this could go under elabelDataImport import type
 */
export const elabelFields = [
  // {
  //   key: 'elabel.productType',
  //   label: 'E-label product type',
  // },
  // {
  //   key: 'elabel.name',
  //   label: 'E-label private name',
  // },
  {
    key: 'product.energyKj',
    label: 'Energy in kJ',
  },
  {
    key: 'product.energyKcal',
    label: 'Energy in kcal',
  },
  {
    key: 'product.volumeOfPortion',
    label: 'Volume of a portion (ml)',
  },
  {
    key: 'product.fat',
    label: 'Fat per 100ml',
  },
  {
    key: 'product.saturatedFat',
    label: 'Saturates per 100ml',
  },
  {
    key: 'product.carbohydrates',
    label: 'Carbohydrate per 100ml',
  },
  {
    key: 'product.carbohydrateSugars',
    label: 'Sugars per 100ml',
  },
  {
    key: 'product.protein',
    label: 'Protein per 100ml',
  },
  {
    key: 'product.salt',
    label: 'Salt per 100ml',
  },
];
